import { Speciality } from "@mindlercare/schema";
import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { get } from "../services/httpClient";

export const useGetSpecialities = () =>
  useQuery({
    queryKey: ["specialities"],
    queryFn: () =>
      get<{ data: Speciality[] }>("static/specialities").then((r) => r.data),
  });
